export default "__VITE_ASSET__CfqKPg$s__"